module.exports = __webpack_public_path__ + "img/racecourse-greyville-poly-1950.98ef87a5.svg";